export default __webpack_public_path__ + "static/cart-523a81ead0e3bf435174243790de17db.png";